import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Observable } from 'rxjs';
import { ToastrService } from './toastr.service';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private _subject: Subject<any>;
  observer: Observable<any>;

  className = 'LoadingService';

  constructor(private toastService: ToastrService, private translateService: TranslateService) {
    this._subject = new Subject<any>();
    this.observer = this._subject.asObservable()
  }

  loading(data: boolean) {      
    this._subject.next(data);
    if(data) {
      this.toastService.add({ severity: "info", summary: this.translateService.instant("TOAST.GENERAL.INFO_SAVING_TITLE"), detail: this.translateService.instant("TOAST.GENERAL.INFO_SAVING_DETAIL"), life: 20000 });
    }
    else {
      this.toastService.clear()
    }
  }

  loadingError() {
    this._subject.next(false);
  }
}
